export default __webpack_public_path__ + "static/media/THREE2x.23c0d3f9.jpg";